<div class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
  <p class="mb-0">2014 - {{currentYear}} &copy; {{customerName}}.</p>
  <p>Designed &amp; Developed By <a href="javascript:void(0);" class="text-primary">{{customerName}}</a></p>
</div>
